<template>
  <v-container
    grid-list-xl
    fluid
  >
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <v-data-table
          v-model="selected"
          :loading="loading"
          :headers="headers"
          :items="collection"
          :total-items="meta.totalItems"
          :rows-per-page-text="$t('Rows per page')"
          :rows-per-page-items="meta.rowsPerPageItems"
          :pagination.sync="pagination"
          class="elevation-1"
          item-key="id"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          />

          <template v-slot:items="props">
            <CustomerGroupDataTableRow
              :props="props" />
          </template>
          <template v-slot:pageText="props">
            <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MassActionSelect from '../../../vuetify-console/components/MassActionSelect'
import CustomerGroupDataTableRow from '../components/CustomerGroupDataTableRow'

import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('customers/groups')

export default {
  name: 'CustomerGroupList',

  components: {
    CustomerGroupDataTableRow,
    MassActionSelect
  },

  actionBar () {
    return {
      title: 'Customer Groups',
      actions: [
        {
          text: 'Add new Group',
          event: 'add'
        }
      ]
    }
  },

  data () {
    return {
      selected: [],
      searchQuery: ''
    }
  },

  computed: {
    ...mapGetters(['collection', 'loading', 'meta', 'appliedFilters']),

    pagination: {
      get: function () {
        return this.meta
      },
      set: function (value) {
        this.applyMeta(value)
      }
    },

    headers () {
      return [
        { text: this.$t('Code'), value: 'code' },
        { text: this.$t('Name'), value: 'name' }
      ]
    }
  },

  methods: {
    ...mapActions(['applyMeta', 'fetchCollection']),

    setSearchQuery (query) {
      this.searchQuery = query
    },

    onActionAdd () {
      this.$router.push({ name: 'new-customer-group' })
    }
  }
}
</script>
